// extracted by mini-css-extract-plugin
export default {"root":"SidebarItem_root__FDHRT","link":"SidebarItem_link__3pRBP","active":"SidebarItem_active__6o-T2"};